import React from 'react';

function Error({ children }) {
  return (<p style={{ color: "red" }}>{children}</p>);
}

export default Error;